// Libraries
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { DelcoteProductsStyle } from "./DelcoteProductsStyle";

import { isNullOrUndefined } from "Custom/Utils/Utils";

import { Delcote10 } from "./DelcoteSubViews/Delcote10";
import { Delcote25 } from "./DelcoteSubViews/Delcote25";
import { DelcoteAsbestos } from "./DelcoteSubViews/DelcoteAsbestos";

import { DelglazeViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelglazeViewModel";
import { DelcoteProductsViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelcoteProductsViewModel";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/ProductsCommonViewModel";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    delglazeViewModel: DelglazeViewModel;
    viewModel: DelcoteProductsViewModel;
}

export const DelcoteProducts: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const delcoteProductsStyle = DelcoteProductsStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={delcoteProductsStyle.root}>
            {/*             <BQSRadioButtons
                displayName="What is the roof substrate?"
                execute={props.viewModel.setProductSelection}
                row={false}
                value={!isNullOrUndefined(props.viewModel.productSelection) ? props.viewModel.productSelection.value : undefined}
            >
                {props.viewModel.products.map((item) => (
                    <BQSRadioButton displayName={item.title} key={item.value} value={item.value} />
                ))}
            </BQSRadioButtons> */}
            {props.viewModel.canDisplayMetal10 && (
                <Delcote10 commonViewModel={props.commonViewModel} delglazeViewModel={props.delglazeViewModel} viewModel={props.viewModel.Delcote10ViewModel} />
            )}
            {props.viewModel.canDisplayMetal25 && (
                <Delcote25 commonViewModel={props.commonViewModel} delglazeViewModel={props.delglazeViewModel} viewModel={props.viewModel.Delcote25ViewModel} />
            )}
            {props.viewModel.canDisplayFibreCement && (
                <DelcoteAsbestos commonViewModel={props.commonViewModel} delglazeViewModel={props.delglazeViewModel} viewModel={props.viewModel.DelcoteAsbestosViewModel} />
            )}
        </Box>
    ));

    // #endregion Render Result
};
